import styled from 'styled-components';

export const Room_info_Li_Wrap = styled.div(
  props => `
      display: flex;
      align-items: center;
      position:relative;
        &:hover ${ToolTipTextDiv} {
      visibility: visible;
    }
      `,
);

export const ToolTipTextDiv = styled.div(
  props => `
    display:flex;
    width:fit-content;
    border-radius: 0.6rem;
    z-index: 1;
    position: relative;
    background-color: #e9f6ea;    
  `,
);

export const ToolTipInnerContent = styled.div(
  props => `
    display:flex;
    width:100%;
    ${props.viewForOldCard ? 'flex-direction: column; padding: 0.5rem;' : 'align-items: center;'}
  `,
);

export const Extra_Bed_Left_Wrap = styled.span(
  props => `
    display:flex;
    align-items: center;
    background: ${props.bgColor || props.theme.colors.goGreen.base};
    padding:0.4rem ${props.theme.spacing.base};
    border-radius: 0.6rem;
    color: ${props.textColor || props.theme.colors.goWhite.base};
    font-size: ${props.theme.font.custom(12)};
    font-weight: 600;
    border-color: ${props.borderColor || ''};
    position: relative;
    ${props.viewForOldCard ? 'align-self: flex-start' : ''};
    ${
      props.isContent && !props.viewForOldCard
        ? `&::after {
      content: "";
      position: absolute;
      bottom: 100%;
    left:11px;
      border-width: 0.8rem;
      border-style: solid;
      border-color: transparent transparent #18a160 transparent;
    }`
        : ''
    }
    `,
);

export const Extra_Bed_Right_Wrap = styled.span(
  props => `
    padding: ${props.viewForOldCard ? '0.4rem 0 0 0;' : `0.4rem ${props.theme.spacing.base};`}
    font-size: ${props.theme.font.custom(12)};
    color: #18a160;
    background: ${props.bgColor || props.theme.colors.goGreen.light};
    color: ${props.textColor || props.theme.colors.goGreen.dark};
    border-radius: 0.6rem;
    `,
);
